import * as React from 'react';

import styles from './state-hover-tooltip.module.css';

type Props = {
    stateName: string;
    dataPoint: string;
};

export function StateHoverTooltip(props: Props) {
    return (
        <div className={styles['tooltip-container']}>
            <div>{props.stateName}</div>
            <strong>{props.dataPoint}</strong>
        </div>
    );
}
